import * as api from '../api/invoiceNumber'
import { DocumentTypes, InvoiceDocumentNumberType } from '../Interfaces/Draft/DraftInterface'
import { actionCreator, actionCreatorAsync } from './'
import { navigateAddModal } from './navigation'

export enum Type {
  GET_INVOICE_NUMBER_SEQUENCES = 'GET_INVOICE_NUMBER_SEQUENCES',
  CREATE_INVOICE_NUMBER_SEQUENCE = 'CREATE_INVOICE_NUMBER_SEQUENCE',
  ACTIVATE_INVOICE_NUMBER_SEQUENCE = 'ACTIVATE_INVOICE_NUMBER_SEQUENCE',
}

export const getInvoiceNumberSequences = () => {
  return actionCreatorAsync<InvoiceDocumentNumberType[]>(Type.GET_INVOICE_NUMBER_SEQUENCES, async () => {
    return await api.getDocumentNumberSequences(DocumentTypes.INVOICE)
  })
}

export const createInvoiceNumberSequence = (newSequence: InvoiceDocumentNumberType) => {
  return actionCreatorAsync<InvoiceDocumentNumberType>(Type.CREATE_INVOICE_NUMBER_SEQUENCE, async () => {
    return await api.createDocumentNumberSequence(DocumentTypes.INVOICE, newSequence)
  })
}

export const activateInvoiceNumberSequence = actionCreator<InvoiceDocumentNumberType['prefix']>(
  Type.ACTIVATE_INVOICE_NUMBER_SEQUENCE,
)

export const openInvoiceNumberEditModal = () => {
  return async (dispatch, getState) => {
    dispatch(
      navigateAddModal({
        component: 'InvoiceNumberSequenceModal',
      }),
    )
  }
}
